export default "__VITE_ASSET__D$nwyE56__"